export default __webpack_public_path__ + "static/10-7e02f20d9613411a262d1b5caf5892d3.jpg";